function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
export {
  _classCallCheck as default
};
//# sourceMappingURL=classCallCheck.js.map
